import { useEffect, useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { hideScroll, resetScroll } from './helpers.js';
export const useModalState = ({ onClose, onAfterClose } = {}) => {
    const [isMounted, setIsMounted] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [payload, setPayload] = useState(null);
    const open = useCallbackRef((newPayload) => {
        hideScroll();
        setPayload(newPayload);
        setIsMounted(true);
        setIsOpen(true);
    });
    const close = useCallbackRef(() => {
        setIsOpen(false);
        onClose?.();
    });
    const debouncedResetScroll = useDebouncedCallback(resetScroll, 100);
    const afterClose = useCallbackRef(() => {
        resetScroll();
        setIsMounted(false);
        setPayload(null);
        onAfterClose?.();
    });
    useEffect(() => {
        window.addEventListener('resize', debouncedResetScroll);
        return () => {
            window.removeEventListener('resize', debouncedResetScroll);
        };
    }, [debouncedResetScroll]);
    return useMemo(() => {
        if (isMounted) {
            return {
                isOpen,
                isMounted: true,
                payload: payload,
                open,
                close,
                afterClose,
            };
        }
        return {
            isOpen: false,
            isMounted: false,
            payload: null,
            open,
            close,
            afterClose,
        };
    }, [afterClose, close, isMounted, isOpen, open, payload]);
};
